import { traducirError, useTraduccion } from '@tallerya/i18n';
import { AvisoError, Boton, useAvisos, Ventana } from '@tallerya/ui';
import { useState } from 'react';
import { useCambiosCatalogos, type Categoria } from './datos';

// «Configuraciones - Catálogos (Eliminar categoría)» del Figma. Solo se ofrece
// para la que ningún ítem tiene (`isDeletable`), y dice por qué no se pierde
// nada. Si en el medio alguien la usó, la API la rechaza y el motivo se dice acá.

interface Props {
  categoria: Categoria | null;
  onCerrar: () => void;
}

export function EliminarCategoria({ categoria, onCerrar }: Props) {
  const { t } = useTraduccion();
  const { avisar } = useAvisos();
  const cambios = useCambiosCatalogos();
  const [eliminando, setEliminando] = useState(false);
  const [problema, setProblema] = useState<string | null>(null);

  function cerrar() {
    if (eliminando) return;
    setProblema(null);
    onCerrar();
  }

  async function eliminar() {
    if (!categoria) return;
    setEliminando(true);
    setProblema(null);
    try {
      const error = await cambios.eliminarCategoria(String(categoria.id));
      if (error) {
        setProblema(error.code ? traducirError(error.code, t) : t('ui.formulario.aviso.sinRespuesta'));
        return;
      }
    } catch {
      // Sin red la petición lanza; sin esto «Cancelar» quedaba apagado (#124).
      setProblema(t('ui.formulario.aviso.sinRespuesta'));
      return;
    } finally {
      setEliminando(false);
    }
    avisar({ titulo: t('admin.catalogos.categorias.aviso.eliminada', { nombre: categoria.name }) });
    onCerrar();
  }

  return (
    <Ventana
      abierta={categoria !== null}
      titulo={categoria ? t('admin.catalogos.categorias.eliminar.titulo', { nombre: categoria.name }) : ''}
      descripcion={t('admin.catalogos.categorias.eliminar.texto')}
      acciones={
        <>
          <Boton variante="texto" disabled={eliminando} onClick={cerrar}>
            {t('app.cancelar')}
          </Boton>
          <Boton variante="peligro" disabled={eliminando} aria-busy={eliminando} onClick={() => void eliminar()}>
            {t('admin.catalogos.eliminar')}
          </Boton>
        </>
      }
    >
      {problema && <AvisoError aviso={{ titulo: t('admin.catalogos.error.titulo'), texto: problema }} />}
    </Ventana>
  );
}
